import React, { Component } from 'react';
import {
  withAuthenticator,
  ConfirmSignUp,
  VerifyContact,
} from 'aws-amplify-react';
import { Helmet } from 'react-helmet';
import CONFIGS from 'configs';
import Router from './navigation/Router';
import ErrorBoundary from './ErrorBoundary';
import SignIn from './features/auth/components/SignIn';
import ConfirmSignIn from './features/auth/components/ConfirmSignIn';
import NewPassword from './features/auth/components/NewPassword';
import ForgotPassword from './features/auth/components/ForgotPassword';

const authComponents = [
  <SignIn />,
  <ConfirmSignIn />,
  <NewPassword />,
  <ConfirmSignUp />,
  <VerifyContact />,
  <ForgotPassword />,
];

class Root extends Component {
  render() {
    return <Router />;
  }
}

const AuthRoot = withAuthenticator(Root, {
  includeGreetings: false,
  authenticatorComponents: authComponents,
});

const App = () => (
  <ErrorBoundary>
    <Helmet
      titleTemplate={`${CONFIGS.APP_TITLE} - %s`}
      defaultTitle={CONFIGS.APP_TITLE}
    >
      <meta name="description" content={CONFIGS.APP_TITLE} />
    </Helmet>
    <AuthRoot />
  </ErrorBoundary>
);

export default App;
